export const RED_700 = '#d32f2f';

export const BLUE_700 = '#1976d2';

export const GREEN_700 = '#388e3c';

export const OYO_THEME = 'rgb(225,40,40)';